module.exports = __webpack_public_path__ + "img/haya-ico.e3198e45.png";